module.exports = __webpack_public_path__ + "img/upload.0a6b3710.svg";